import TextBookApi from '../../../api/src/textbook/api/TextBookApi'
// import TextBookApiV2 from "../../../api/src/textbook_v2/api/TextBookV2Api"
import AuditApi from "../../../api/src/textbook_v2/api/AuditApi"
import {listToTree} from '../../../utils'
import {message} from "ant-design-vue";

const textBookApi = new TextBookApi();
// const textbookApi_v2 = new TextBookApiV2();
const auditApi = new AuditApi();

const state = {
  category: [],
  hasNextPage: true,
  pageNum: 0,
  list: []
}

const mutations = {
  addMajorList(state, data) {
    state.majorList = data || []
  },
}

const actions = {
  async getCategory({commit, state}, data) {
    let resp = await textBookApi.textBookCategory()
    state.category = listToTree(resp)
  },
  async findPagingTextBook({commit, state}, {categoryId, isRefresh}) {
    if(isRefresh){
      state.pageNum = 1
    }else{
      state.pageNum = state.pageNum + 1
    }
    let resp = await textBookApi.findPagingTextBook(state.pageNum, {categoryId})
    if(isRefresh){
      state.hasNextPage = resp.hasNextPage
      state.list = resp.list
    }else{
      let list = [...state.list]
      list = list.concat(resp.list)
      state.hasNextPage = resp.hasNextPage
      state.list = list
    }
  },
  async addTextBook({commit, state}, data) {
    let resp = await textBookApi.addTextBook(data)
    console.log(resp)
  },
  async deleteTextBook({commit, state}, {id}) {
    let resp = await textBookApi.deleteTextBook(id)
    console.log(resp)
  },
  async findTextBookById({commit, state}, {id}) {
    return await textBookApi.findTextBookById(id)
  },
  async updateTextBook({commit, state}, data) {
    return await textBookApi.updateTextBook(data.id, data)
  },
  async getToc({commit, state}, {id, type}) {
    return await textBookApi.getToc(id, type)
  },

  async getTocV2({commit, state}, {id, type}) {
    return await textBookApi.getToc(id, type)
  },
  async addUnit({commit, state}, data) {
    return await textBookApi.addUnit(data)
  },
  async updateUnit({commit, state}, data) {
    return await textBookApi.updateUnit(data.id, data)
  },
  async deleteUnit({commit, state}, {id}) {
    return await textBookApi.deleteUnit(id)
  },
  async dragUnit({commit, state}, {id, pid, sortKey}) {
    return await textBookApi.dragUnit({id, pid, sortKey})
  },
  async addLesson({commit, state}, data) {
    return await textBookApi.addLesson(data)
  },
  async updateLesson({commit, state}, data) {
    return await textBookApi.updateLesson(data.id, data)
  },
  async deleteLesson({commit, state}, {id}) {
    return await textBookApi.deleteLesson(id)
  },
  async dragLesson({commit, state}, {id, pid, sortKey}) {
    return await textBookApi.dragLesson({id, pid, sortKey})
  },
  async addSection({commit, state}, data) {
    return await textBookApi.addSection(data)
  },
  async updateSection({commit, state}, data) {
    return await textBookApi.updateSection(data.id, data)
  },
  async deleteSection({commit, state}, {id}) {
    return await textBookApi.deleteSection(id)
  },
  async dragSection({commit, state}, {id, pid, sortKey}) {
    return await textBookApi.dragSection({id, pid, sortKey})
  },

  async auditAction({commit, state}, data) {
    return await auditApi.createAudit(data)
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}